import React from 'react';
import DSEScoreInputer from '../../widgets/DSEScoreInputer';
import { PROMO_DEMO_DSE_SCORES } from '../../../data/promotionalHomeDemo';
import { promoEmbedBodyClass } from './PromotionalEmbedCta';

const promoDseShellClass =
  'mt-6 flex min-h-0 flex-1 flex-col rounded-2xl bg-surface p-4 sm:p-5 shadow-sm border border-edge text-left';

const PromotionalJupasPredictEmbed = ({ onScoresChange }) => {
  return (
    <div className={promoDseShellClass}>
      <div className={`promo-dse-embed overflow-y-auto overflow-x-hidden pr-2 ${promoEmbedBodyClass}`}>
        <DSEScoreInputer
          embedded
          demoScores={PROMO_DEMO_DSE_SCORES}
          onScoresChange={onScoresChange}
        />
      </div>
    </div>
  );
};

export default PromotionalJupasPredictEmbed;
